import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Table } from 'src/components';
import { onlyNumber, roundFloat } from 'src/core/utils/formater';
import { PlusCircleOutlined } from '@ant-design/icons';
import {
  Modal,
  Form,
  Row,
  Col,
  Button,
  Typography,
  Input,
  Divider,
  Select,
} from 'antd';
import newAlert from 'src/components/newAlert';
import CustomDatePicker from 'src/components/common/datePicker';
import { huuliData } from 'src/data/huuliData';
import { yamList } from 'src/data/yamsData';
import { customColumns, customSummary } from './dataStructure/data';
import { start_loading, end_loading } from '../../../core/actions/loader';

// Импорт: Нэг газраас

const { Text } = Typography;
const { Option } = Select;

const turulOptions = {
  1: '1.хөрөнгө оруулалт',
  2: '2.санхүүгийн дэмжлэг',
  3: '3.хандив',
};

const MainPage = () => {
  const dispatch = useDispatch();
  const socket = useSelector((state) => state.socket);
  const data_date = useSelector((state) => state.data_date);

  const [tableData, setTableData] = useState([]);
  const [tableDataSum, setTableDataSum] = useState({});
  const [addVisible, setAddVisible] = useState(false);
  const [updateVisible, setUpdateVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);

  const [addForm] = Form.useForm();
  const [updateForm] = Form.useForm();
  const [deleteForm] = Form.useForm();

  const generateTailan = (month) => {
    socket.on('request_out', ({ status, content }) => {
      socket.removeAllListeners('request_out');
      if (status === '0') {
        setTableData(content?.table_data || []);
        setTableDataSum(content?.total_dun || {});
      }
      dispatch(end_loading({}));
    });
    socket.emit('request_in', {
      channel: 'ts007_00_hungulult_manage',
      content: { action_type: 'get_tm1a', month: String(month) },
    });
    dispatch(start_loading({}));
  };

  const deleteValue = (deleteData) => {
    socket.on('request_out', (data) => {
      socket.removeAllListeners('request_out');
      if (data.status === '0') {
        newAlert({ type: 'success', msg: 'Амжилттай устгагдлаа' });
        generateTailan(data_date.month);
      } else {
        newAlert({
          type: 'error',
          msg: data.content?.Message || 'Системд алдаа гарлаа',
        });
      }
      dispatch(end_loading({}));
      generateTailan(data_date.month);
    });
    socket.emit('request_in', {
      channel: 'ts007_00_hungulult_manage',
      content: { action_type: 'delete_tm1a', id: deleteData.delete_id },
    });
    dispatch(start_loading({}));
  };

  const addValue = (saveData) => {
    socket.on('request_out', ({ status, content }) => {
      socket.removeAllListeners('request_out');
      newAlert({
        type: status === '0' ? 'success' : 'error',
        msg: content.Message,
        functions: { onSuccess: [() => generateTailan(data_date.month)] },
      });
      dispatch(end_loading({}));
      generateTailan(data_date.month);
    });
    socket.emit('request_in', {
      channel: 'ts007_00_hungulult_manage',
      content: {
        action_type: 'add_tm1a',
        action_data: saveData,
        month: String(data_date.month),
      },
    });
    dispatch(start_loading({}));
  };

  const updateValue = (saveData) => {
    socket.on('request_out', ({ status, content }) => {
      socket.removeAllListeners('request_out');
      newAlert({
        type: status === '0' ? 'success' : 'error',
        msg: content.Message,
        functions: { onSuccess: [() => generateTailan(data_date.month)] },
      });
      dispatch(end_loading({}));
      generateTailan(data_date.month);
    });
    socket.emit('request_in', {
      channel: 'ts007_00_hungulult_manage',
      content: {
        action_type: 'update_tm1a',
        action_data: saveData,
        month: String(data_date.month),
      },
    });
    dispatch(start_loading({}));
  };

  useEffect(() => {
    if (data_date?.month) {
      generateTailan(data_date.month);
    }
  }, [data_date]);

  const addAction = () => {
    addForm.resetFields();
    setAddVisible(true);
  };

  const updateAction = (row) => {
    updateForm.setFieldsValue({
      id: row.id,
      ttd_avsan: row.ttd_avsan,
      ner_avsan: row.ner_avsan,
      ognoo: row.ognoo,
      tulbur_dugaar: row.tulbur_dugaar,
      turul: row.turul,
      zoriulalt: row.zoriulalt,
      huuli_dugaar: row.huuli_dugaar,
      total_dun: roundFloat(row.total_dun),
      tai_dun: roundFloat(row.tai_dun),
      yam:
        row.yam
          ?.split(',')
          .map((y) => y.trim())
          .filter(Boolean)
          .map((y) => yamList[y]) || [],
    });
    setUpdateVisible(true);
  };

  const deleteAction = (row) => {
    deleteForm.setFieldsValue({ delete_id: row?.id });
    setDeleteVisible(true);
  };

  const title = () => (
    <>
      <div className="table-title-text-center">
        Хөнгөлөлтийн мэдээний тодруулга /ТМ-1а/
      </div>
      <Button
        className="add-btn"
        type="primary"
        size="small"
        icon={<PlusCircleOutlined />}
        onClick={addAction}
      >
        Нэмэх
      </Button>
    </>
  );

  return (
    <>
      <div className="table-antd-div no-scroll">
        <Table
          columns={customColumns({
            customEdit: updateAction,
            customDelete: deleteAction,
          })}
          dataSource={tableData}
          scroll={{ x: 'max-content' }}
          summaryList={{
            sumColumn: customSummary,
            sumDataSource: tableDataSum,
          }}
          title={title}
        />
      </div>

      {/* ADD MODAL */}
      <Modal
        className="custom-modal"
        title="Мэдээлэл нэмэх"
        open={addVisible}
        onCancel={() => {
          addForm.resetFields();
          setAddVisible(false);
        }}
        destroyOnClose
        width={950}
        footer={null}
      >
        <FormModal
          form={addForm}
          onClose={() => {
            addForm.resetFields();
            setAddVisible(false);
          }}
          saveValues={addValue}
          isUpdate={false}
        />
      </Modal>

      {/* UPDATE MODAL */}
      <Modal
        className="custom-modal"
        title="Мэдээлэл засах"
        open={updateVisible}
        onCancel={() => {
          updateForm.resetFields();
          setUpdateVisible(false);
        }}
        destroyOnClose
        width={950}
        footer={null}
      >
        <FormModal
          form={updateForm}
          onClose={() => {
            updateForm.resetFields();
            setUpdateVisible(false);
          }}
          saveValues={updateValue}
          isUpdate
        />
      </Modal>

      {/* DELETE MODAL */}
      <Modal
        className="custom-modal"
        title="Бүртгэл устгах"
        open={deleteVisible}
        onCancel={() => {
          deleteForm.resetFields();
          setDeleteVisible(false);
        }}
        destroyOnClose
        width={500}
        footer={null}
      >
        <DeleteModal
          form={deleteForm}
          onClose={() => {
            deleteForm.resetFields();
            setDeleteVisible(false);
          }}
          deleteValue={deleteValue}
        />
      </Modal>
    </>
  );
};

/* ─────────────────────── НЭГТГЭСЭН FORM MODAL ─────────────────────── */
const layout = {
  labelCol: { xs: { span: 12 }, sm: { span: 10 } },
  wrapperCol: { xs: { span: 12 }, sm: { span: 14 } },
};

const FormModal = ({ form, onClose, saveValues, isUpdate }) => {
  const [yamOptions, setYamOptions] = useState([]);

  const onFinish = (values) => {
    const cleaned = {
      ...(isUpdate && { id: values.id }),
      ...values,
      total_dun: values.total_dun?.replace(/,/g, '') || null,
      tai_dun: values.tai_dun?.replace(/,/g, '') || null,
      yam: Array.isArray(values.yam)
        ? values.yam
            .map((name) =>
              Object.keys(yamList).find((k) => yamList[k] === name)
            )
            .join(',')
        : values.yam,
    };
    delete cleaned.zaalt; // Хадгалахгүй
    saveValues(cleaned);
    form.resetFields();
    onClose();
  };

  const handleHuuliChange = (huuliKey) => {
    console.log('huuliKey', huuliKey);

    const item = huuliData[huuliKey]; // 22.9.1 → object
    if (!item) {
      form.setFieldsValue({ zaalt: '', yam: [] });
      setYamOptions([]);
      return;
    }

    form.setFieldsValue({
      zaalt: item.text,
      yam: item.yam.length === 1 ? [yamList[item.yam[0]]] : [],
    });
    setYamOptions(item.yam.map((id) => yamList[id])); // [1,2] → ['Хот...', 'Байгаль...']
  };

  useEffect(() => {
    if (isUpdate) {
      const huuli = form.getFieldValue('huuli_dugaar');
      if (huuli) handleHuuliChange(huuli);
    }
  }, [form, isUpdate]);

  return (
    <Form form={form} onFinish={onFinish} {...layout} size="small">
      {isUpdate && <Form.Item name="id" hidden />}

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="ttd_avsan" label="ТТД" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="ner_avsan" label="Нэр" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="ognoo" label="Огноо" rules={[{ required: true }]}>
            <CustomDatePicker format="YYYY-MM-DD" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="tulbur_dugaar"
            label="Төлбөрийн баримтын дугаар"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="turul" label="Төрөл" rules={[{ required: true }]}>
            <Select placeholder="Төрөл сонгоно уу">
              {Object.entries(turulOptions).map(([k, v]) => (
                <Option key={k} value={k}>
                  {v}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="zoriulalt"
            label="Зориулалт"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="huuli_dugaar"
            label="Хуулийн дугаар"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Дугаар сонгоно уу"
              onChange={handleHuuliChange}
              showSearch
              optionFilterProp="children"
            >
              {Object.entries(huuliData).map(([id, d]) => (
                <Option key={id} value={Number(id)}>
                  {d.key} {/* 22.9.1 гэж харагдана */}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="zaalt" label="Хуулийн заалт">
            <Input.TextArea rows={3} disabled />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="total_dun"
            label="Нийт дүн"
            normalize={onlyNumber}
            rules={[{ required: true }]}
          >
            <Input className="text-align-r" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="tai_dun"
            label="Тайланд тусгасан дүн"
            normalize={onlyNumber}
          >
            <Input className="text-align-r" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        name="yam"
        label="Хяналт тавих яам"
        rules={[{ required: true }]}
      >
        <Select
          mode={yamOptions.length > 1 ? 'multiple' : 'default'}
          placeholder={
            yamOptions.length
              ? 'Яам сонгоно уу'
              : 'Эхлээд хуулийн дугаар сонгоно уу'
          }
          disabled={!yamOptions.length}
        >
          {yamOptions.map((name, idx) => (
            <Option key={idx} value={name}>
              {name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Divider />
      <Row>
        <Col span={24} className="text-align-r">
          <Button
            onClick={onClose}
            className="cancel-btn"
            type="primary"
            shape="round"
          >
            Цуцлах
          </Button>
          <Button
            className="confirm-btn ml-5"
            type="primary"
            shape="round"
            htmlType="submit"
          >
            {isUpdate ? 'Шинэчлэх' : 'Хадгалах'}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

/* ─────────────────────── DELETE MODAL ─────────────────────── */
const DeleteModal = ({ form, onClose, deleteValue }) => {
  const onFinish = (values) => {
    deleteValue(values);
    form.resetFields();
    onClose();
  };

  return (
    <Form form={form} onFinish={onFinish} {...layout} size="small">
      <Form.Item name="delete_id" hidden />
      <Text>Та энэ үйлдлийг хийхдээ итгэлтэй байна уу?</Text>
      <Row>
        <Col span={24} className="text-align-r">
          <Button
            onClick={onClose}
            className="cancel-btn"
            type="primary"
            shape="round"
          >
            Цуцлах
          </Button>
          <Button
            className="confirm-btn ml-5"
            type="primary"
            shape="round"
            htmlType="submit"
          >
            Устгах
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default MainPage;
